import { render, staticRenderFns } from "./RoteiroHome.vue?vue&type=template&id=22735643"
import script from "./RoteiroHome.vue?vue&type=script&lang=js"
export * from "./RoteiroHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports